import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/learn/$slug")({
  loader: () => {
    throw notFound();
  },
  component: () => null,
});